var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 604",
    style: {
      enableBackground: "new 0 0 1920 604"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M737.27,138.62H138.55v326.76h108.57l64.88,69.31l64.88-69.31h360.4c90.18,0,163.29-73.15,163.29-163.38v0 C900.56,211.77,827.45,138.62,737.27,138.62z M737.27,356.46H247.41V247.54h489.86c30.01,0,54.43,24.43,54.43,54.46 C791.7,332.03,767.28,356.46,737.27,356.46z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1081.89,236.31h-67.58v131.38h67.58c29.63,0,53.64-24.03,53.64-53.67v-24.04 C1135.53,260.34,1111.51,236.31,1081.89,236.31z M1110.05,314.02c0,15.54-12.63,28.18-28.16,28.18h-42.1V261.8h42.1 c15.53,0,28.16,12.64,28.16,28.18V314.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.03,289.7h-41.9c-7.44,0-13.5-6.06-13.5-13.51c0-7.45,6.06-13.51,13.5-13.51h73.11V237.2h-73.11 c-21.49,0-38.98,17.5-38.98,39c0,21.5,17.49,39,38.98,39h41.9c7.44,0,13.5,6.06,13.5,13.51v0.4c0,7.45-6.06,13.51-13.5,13.51h-75.9 v25.49h75.9c21.49,0,38.98-17.5,38.98-39v-0.4C1452.01,307.2,1434.52,289.7,1413.03,289.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.81,237.42h-23.5h-2.61l-55.62,130.46h27.64l12.96-31.26v0.89h59.13l12.59,30.37h27.64l-55.62-130.46H1244.81z  M1212.93,314.31l20.13-48.54l20.13,48.54H1212.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.45,367.88l-51.59-130.46h-2.61h-23.5h-2.61l-55.62,130.46h27.64l12.96-31.26v0.89h56.04l11.66,30.37H1781.45z  M1695.37,314.31l19.67-47.45l18.21,47.45H1695.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1583.34,291.05 1521.87,291.05 1521.87,237.42 1495.61,237.42 1495.61,367.88 1521.87,367.88 1521.87,314.25  1583.34,314.25 1583.34,367.88 1609.6,367.88 1609.6,237.42 1583.34,237.42  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashaLogo);
export default __webpack_public_path__ + "static/media/dasha-logo.81c8fcaddbc32b7fb4f4a3da7d235525.svg";
export { ForwardRef as ReactComponent };